import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Suspense } from 'react';
import { Toaster } from '@/components/ui/sonner';
import type { Session } from '@/lib/auth-client';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: Session | null;
  setOrganizationId: (id: string) => void;
}>()({
  head: () => ({
    meta: [
      { title: 'FeatureBuddy' },
      {
        name: 'description',
        content:
          'FeatureBuddy helps you collect, manage, and prioritize mobile app feedback. Get quick integration and user voting to build the features your users love.',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:site',
        content: '@featurebuddyhq',
      },
      {
        name: 'twitter:creator',
        content: '@featurebuddyhq',
      },
      {
        property: 'og:title',
        content: 'FeatureBuddy | Mobile Native Feature Request Management',
      },
      {
        property: 'og:description',
        content:
          'FeatureBuddy helps you collect, manage, and prioritize mobile app feedback. Get quick integration and user voting to build the features your users love.',
      },
      {
        property: 'og:image',
        content: 'https://featurebuddy.com/og-image.png',
      },
      {
        property: 'og:url',
        content: 'https://app.featurebuddy.com',
      },
      {
        property: 'og:type',
        content: 'website',
      },
    ],
  }),
  component: () => (
    <>
      <Suspense fallback={null}>
        <HeadContent />
        <Outlet />
        <Toaster />
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  ),
});
